// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1a_RA","imageUploader":"EGiftCard_imageUploader__qFdBk"};